import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Unstable_Grid2';
import { CardContent, List, Modal, Typography } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import './CrApp.css';


export default function TvShowContentCard({image, tvShowName, content }) {
    const [height, setHeight] = React.useState(window.innerHeight);
    const [width, setWidth] = React.useState(window.innerWidth);

    //handle modal states
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const [openSeasons, setOpenSeasons] = React.useState({});
    const handleEpisodeClick = (season) => {
        setOpenSeasons((prev) => ({
            ...prev,
            [season]: !prev[season]
        }));
    };

    function sortEpisodeArr(arr) {
        const newArr = arr.map((str) => {
            return str.replace(/^\D+/g, '');
        });
        newArr.sort((a, b) => a - b);
    
        const finalArr = newArr.map(newObj => `Episode ${newObj}`);
        return finalArr;
    }

    const orderedContent = Object.keys(content).sort().reduce(
        (obj, key) => { 
          obj[key] = content[key]; 
          return obj;
        }, 
        {}
      );
    
    //content = sortedSeasonKeys(content);
    //console.log(content);

    React.useEffect(() => {
      const handleResize = () => {
        setHeight(window.innerHeight);
        setWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    let imageHeight = height / 2;
    let imageWidth = width / 5;
    return (
        <Grid xs={6} sm={4} md={3}>
            <Card onClick={handleOpen}
                sx={{ maxWidth: imageWidth }}
                className="content-card">
                <CardMedia
                    component="img"
                    sx={{
                        height: imageHeight,
                        width: '100%',
                        objectFit: 'contain',
                      }}
                    image={image}
                    alt={tvShowName}
                />
            </Card>
            <Modal 
                open={open} 
                onClose={handleClose}
                slotProps={{
                    backdrop: {
                        onClick: handleClose,
                    },
                }} 
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: window.innerWidth / 1.1,
                    height: window.innerHeight /1.15,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2}}>
                <Card className='modal-content-card' onClick={(e) => e.stopPropagation()} sx={{ position: "relative" }}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 10,
                            color: "black",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <CardMedia
                        component="img"
                        alt={tvShowName}
                        sx={{
                          height: '100%',
                          width: '55%',
                          objectFit: 'contain',
                          bgcolor: 'grey'
                        }}
                        image={image}
                    />
                    <CardContent>
                        <Typography>
                            {tvShowName}
                        </Typography>
                        <List sx={{maxHeight:'100%', overflow:'auto'}}>
                            {Object.entries(orderedContent).map(([season, episodes]) => {
                                episodes = sortEpisodeArr(episodes)
                                return (
                                    <React.Fragment key={season}>
                                        <ListItemButton onClick={() => handleEpisodeClick(season)}>
                                            <ListItemText primary={`${season}`} />
                                            {openSeasons[season] ? <ExpandLess /> : <ExpandMore />}
                                        </ListItemButton>
                                        <Collapse in={openSeasons[season]} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {episodes.map((episode, index) => (
                                                    <ListItemButton 
                                                        key={index} 
                                                        sx={{ pl: 4 }} 
                                                        href={`/TvShows/${tvShowName.replace(/\s/g, '')}/${season.replace(/\s/g, '')}/${episode.replace(/\s/g, '%20')}`}>
                                                        <ListItemText primary={`${episode.replace(/\.\w\w\w/g,"")}`} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </React.Fragment>
                                );
                            })}
                        </List>
                    </CardContent>
                </Card>
            </Modal>
        </Grid>
    );
}